import React, { useState, useEffect } from 'react';
import Network from './Requests';
import { useTranslation } from 'react-i18next';

export default function CalculationInfo(props) {
  const { t } = useTranslation();
  const [info, setInfo] = React.useState([]);

  // Если нужно подтягивать данные — раскомментируй блок ниже
  // useEffect(() => {
  //   new Network().GetOutputs(props.variant).then((result) => {
  //     if (result?.data !== 'false' && Array.isArray(result)) {
  //       setInfo(result);
  //     } else {
  //       setInfo([]);
  //     }
  //   }).catch(() => setInfo([]));
  // }, [props.variant]);

  return (
    <div className="infoList">
      <div className="infoList--title">{t('calculationInfo.title')}</div>
      {info.length > 0 ? (
        info.map((i, idx) => (
          <div key={idx} className="infoList--item">
            {i.name} : {i.hint}
          </div>
        ))
      ) : (
        <span>{t('calculationInfo.empty')}</span>
      )}
    </div>
  );
}
